module.exports = __webpack_public_path__ + "/img/app-store-logo.1cfd5dba4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/app-store-logo.svg
// module id = 1387
// module chunks = 0